<template>
  <v-form v-model="valid" ref="mainForm">
    <CatalogueLive
      code="cours_ouinon"
      v-model="sas.sasEquivalence.desireAjouterCours"
      :live="{ endpoint: 'sas-equivalence', cle: '6143', fileId: sas.sasEquivalence.id }"
    />
    <data-iterator
      :list="sas.sasCours"
      add-new-text="Ajouter un cours"
      :live="{ endpoint: 'sas-cours', sasId: sas.id }"
      :icon="$getIcon('school')"
      :valids="valids"
      ref="dataIterator"
      :opq-if="estOui(sas.sasEquivalence.desireAjouterCours)"
    >
      <template v-slot:show-mode="{ item }">
        <p class="mb-0">{{ item.titreCours }}</p>
        <p class="mb-0">{{ getCatalogueTextById("6404", item.universite) }}</p>
      </template>
      <template v-slot:edit-mode="{ item }">
        <TextFieldLive code="cours_titre" v-model="item.titreCours" :live="liveSasCours(6402, item)" />
        <TextFieldLive code="cours_sigle" v-model="item.sigle" :live="liveSasCours(6403, item)" />
        <NumberLive code="cours_credits" v-model="item.nombreDeCredit" :live="liveSasCours(6408, item)" />
        <CatalogueLive code="cours_universite" v-model="item.universite" :live="liveSasCours(6404, item)" />
        <DatePickerLive code="cours_date" v-model="item.dateReussite" :live="liveSasCours(6406, item)" :maxValue="convertDateToString(new Date())" />
        <MemoLive code="cours_objectifs" v-model="item.objectifsApprentissage" :live="liveSasCours(6407, item)" />
        <FileInput code="cours_preuve" :file="item.preuveCours" :live="liveSasCours(6409, item)" />
      </template>
    </data-iterator>
  </v-form>
</template>
<script>
import DatesHelpers from "@/components/ui/mixins/DatesHelpers"
import StepFormWithValidation from "@/mixins/StepFormWithValidation"
import CataloguesHelpers from "@/components/ui/mixins/CataloguesHelpers"
export default {
  mixins: [StepFormWithValidation, CataloguesHelpers, DatesHelpers],
  props: {
    sas: { type: Object }
  },
  methods: {
    liveSasCours(cle, item) {
      return { endpoint: "sas-cours", cle: cle, fileId: item.id }
    }
  }
}
</script>

<style>
</style>